var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.036,
    height: 67.822,
    viewBox: "0 0 82.036 67.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(11.734 -3.831) rotate(11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    d: "M6,15a3,3,0,0,1,3-3H20.978a3,3,0,0,1,0,5.991H9A3,3,0,0,1,6,15Z",
    transform: "translate(5.983 7.478)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    d: "M11.983,4.5A11.983,11.983,0,0,0,0,16.483V46.439A11.983,11.983,0,0,0,11.983,58.422H59.913A11.983,11.983,0,0,0,71.9,46.439V16.483A11.983,11.983,0,0,0,59.913,4.5Zm47.931,5.991H11.983a5.991,5.991,0,0,0-5.991,5.991v20.97H65.9V16.483A5.991,5.991,0,0,0,59.913,10.491ZM65.9,43.444H5.991v3a5.991,5.991,0,0,0,5.991,5.991H59.913A5.991,5.991,0,0,0,65.9,46.439Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.3d4a3d38de5b934c814e73a794f8279c.svg";
export { ForwardRef as ReactComponent };